import { getTenants } from '@/services/core.service'
import type { ITenantFilters } from '@/types/core/filters'
import { useQuery } from '@tanstack/vue-query'
import type { Reactive } from 'vue'

export const useTenants = () => {
  const getTenantsQuery = (filters: Reactive<ITenantFilters>) =>
    useQuery({
      queryKey: ['tenants', filters],
      queryFn: () => getTenants(filters),
    })

  return {
    getTenantsQuery,
  }
}
